import { useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { Container, Form, Content, LoginContainer, Infos } from './styles'
import { useDispatch, useSelector } from 'react-redux'

import * as actions from '../../store/modules/auth/actions'

import { StoreState } from '../../store'
import Aside from '../../components/Aside'
import treepayLogo from '../../assets/treelogo3.svg'

// input password
import { useForm, SubmitHandler } from 'react-hook-form'
import { BsEye, BsEyeSlash } from 'react-icons/bs'
import validator from 'validator'

interface Inputs {
    email: string
    password: string
}

const Login = () => {
    // const [showPassword, setShowPassword] = useState(false)
    const { isLoggedIn } = useSelector((state: StoreState) => state.auth)
    const {
        register,
        handleSubmit,
        formState: { errors, isSubmitting },
    } = useForm<Inputs>()
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const [showPassword, setShowPassword] = useState(false)

    useEffect(() => {
        if (isLoggedIn) navigate('/dashboard')
    }, [navigate, isLoggedIn])

    // function handleClickShowPassword() {
    //     setShowPassword(!showPassword);
    // }

    const submit: SubmitHandler<Inputs> = async (inputs) => {
        dispatch(
            actions.loginRequest({
                email: inputs.email.trim(),
                password: inputs.password,
            })
        )
    }

    const baseStyleInputs =
        'rounded-lg flex-1 appearance-none border border-gray-300 w-full py-2 px-4 bg-white text-gray-700 placeholder-gray-400 shadow-sm text-base focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent mt-1'

    return (
        <Container>
            <Aside />
            <Content>
                {/* <h2 className="title">Ambiente de Homologação</h2> */}
                <LoginContainer>
                    <Infos>
                        <a href="/">
                            <img src={treepayLogo} alt="Logo treepay" />
                        </a>
                        <h1 className="title">Seja bem-vindo(a)!</h1>
                        <p>Informe seus dados abaixo para acessar sua conta</p>
                    </Infos>

                    <Form onSubmit={handleSubmit(submit)}>
                        <div className="field">
                            {/* <TextField type="text" label="Usuário" autoComplete="username" value={login} onChange={(e) => setLogin(e.target.value)} /> */}

                            <div className="relative">
                                <label
                                    htmlFor="email"
                                    className="text-gray-700 text-sm label"
                                >
                                    Email
                                    <span className="text-red-500 required-dot">
                                        *
                                    </span>
                                </label>
                                <input
                                    type="text"
                                    id="email"
                                    autoComplete="email"
                                    {...register('email', {
                                        required: 'O campo email é obrigatório',
                                        minLength: 3,
                                        maxLength: 255,
                                        validate: (value) =>
                                            validator.isEmail(value),
                                    })}
                                    className={
                                        errors.email &&
                                        (errors.email.type === 'required' ||
                                            errors.email.type === 'minLength' ||
                                            errors.email.type === 'maxLength' ||
                                            errors.email.type === 'validate')
                                            ? `${baseStyleInputs} ring-red-500 ring-2`
                                            : baseStyleInputs
                                    }
                                    placeholder="Seu Email"
                                />
                                {errors.email &&
                                    (errors.email.type === 'required' ||
                                        errors.email.type === 'minLength' ||
                                        errors.email.type === 'maxLength' ||
                                        errors.email.type === 'validate') && (
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="15"
                                            height="15"
                                            fill="currentColor"
                                            className="absolute text-red-500 right-2 bottom-3"
                                            viewBox="0 0 1792 1792"
                                        >
                                            <path d="M1024 1375v-190q0-14-9.5-23.5t-22.5-9.5h-192q-13 0-22.5 9.5t-9.5 23.5v190q0 14 9.5 23.5t22.5 9.5h192q13 0 22.5-9.5t9.5-23.5zm-2-374l18-459q0-12-10-19-13-11-24-11h-220q-11 0-24 11-10 7-10 21l17 457q0 10 10 16.5t24 6.5h185q14 0 23.5-6.5t10.5-16.5zm-14-934l768 1408q35 63-2 126-17 29-46.5 46t-63.5 17h-1536q-34 0-63.5-17t-46.5-46q-37-63-2-126l768-1408q17-31 47-49t65-18 65 18 47 49z"></path>
                                        </svg>
                                    )}
                            </div>
                            {errors.email &&
                                errors.email.type === 'validate' && (
                                    <span className="text-red-500 text-sm">
                                        Email inválido
                                    </span>
                                )}
                        </div>
                        <div className="field">
                            <div className="relative">
                                <label
                                    htmlFor="on-error-password"
                                    className="text-gray-700 text-sm label"
                                >
                                    Senha
                                    <span className="text-red-500 required-dot">
                                        *
                                    </span>
                                </label>
                                <input
                                    type={showPassword ? 'text' : 'password'}
                                    autoComplete="current-password"
                                    id="on-error-password"
                                    {...register('password', {
                                        required: 'Senha é obrigatório',
                                        minLength: 3,
                                        maxLength: 255,
                                    })}
                                    className={
                                        errors.password &&
                                        (errors.password.type === 'required' ||
                                            errors.password.type ===
                                                'minLength' ||
                                            errors.password.type ===
                                                'maxLength')
                                            ? `${baseStyleInputs} ring-red-500 ring-2`
                                            : baseStyleInputs
                                    }
                                    placeholder="Sua senha"
                                />
                                <div className="absolute right-2 bottom-3 flex items-center gap-x-2">
                                    {showPassword ? (
                                        <button
                                            type="button"
                                            className=" text-gray-500"
                                            onClick={() =>
                                                setShowPassword(!showPassword)
                                            }
                                        >
                                            <BsEyeSlash size={20} />
                                        </button>
                                    ) : (
                                        <button
                                            type="button"
                                            className=" text-gray-500"
                                            onClick={() =>
                                                setShowPassword(!showPassword)
                                            }
                                        >
                                            <BsEye size={20} />
                                        </button>
                                    )}
                                    {errors.password &&
                                        (errors.password.type === 'required' ||
                                            errors.password.type ===
                                                'minLength' ||
                                            errors.password.type ===
                                                'maxLength') && (
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="15"
                                                height="15"
                                                fill="currentColor"
                                                className=" text-red-500"
                                                viewBox="0 0 1792 1792"
                                            >
                                                <path d="M1024 1375v-190q0-14-9.5-23.5t-22.5-9.5h-192q-13 0-22.5 9.5t-9.5 23.5v190q0 14 9.5 23.5t22.5 9.5h192q13 0 22.5-9.5t9.5-23.5zm-2-374l18-459q0-12-10-19-13-11-24-11h-220q-11 0-24 11-10 7-10 21l17 457q0 10 10 16.5t24 6.5h185q14 0 23.5-6.5t10.5-16.5zm-14-934l768 1408q35 63-2 126-17 29-46.5 46t-63.5 17h-1536q-34 0-63.5-17t-46.5-46q-37-63-2-126l768-1408q17-31 47-49t65-18 65 18 47 49z"></path>
                                            </svg>
                                        )}
                                </div>
                            </div>
                            {/* <FormControl sx={{ width: '100%' }} variant="outlined">
                                    <InputLabel htmlFor="outlined-adornment-password">
                                        Senha
                                    </InputLabel>
                                    <OutlinedInput
                                        id="outlined-adornment-password"
                                        type={showPassword ? "text" : "password"}
                                        value={password}
                                        onChange={(e) => setPassword(e.target.value)}
                                        autoComplete='current-password'
                                        endAdornment={
                                            <InputAdornment position="end">
                                                <IconButton
                                                    aria-label="toggle password visibility"
                                                    onClick={handleClickShowPassword}
                                                    edge="end"
                                                >
                                                    {showPassword ? <VisibilityOff /> : <Visibility />}
                                                </IconButton>
                                            </InputAdornment>
                                        }
                                        label="Password"
                                    />
                                </FormControl> */}
                        </div>
                        <div className="utils">
                            <Link
                                className="text-blue-600 hover:text-blue-500"
                                to="/recuperar-senha"
                            >
                                Esqueci minha senha
                            </Link>
                        </div>
                        <div className="actions">
                            {/* <Button type="submit" variant="outlined" color="success">Entrar</Button> */}
                            <button
                                type="submit"
                                disabled={isSubmitting}
                                className="py-2 px-4  bg-blue-600 hover:bg-blue-700 focus:ring-blue-500 focus:ring-offset-blue-200 text-white w-full transition ease-in duration-200 text-center text-base font-normal shadow-md focus:outline-none focus:ring-2 focus:ring-offset-2  rounded-lg "
                            >
                                Login
                            </button>
                            {/* <Link to='/register' ><Button>Não tenho cadastro</Button></Link> */}
                        </div>
                    </Form>
                </LoginContainer>
                <p className="text-center text-base text-gray-700 mt-auto mb-2">
                    Não possui conta ainda?{' '}
                    <Link
                        className="text-blue-600 hover:text-blue-500 font-semibold "
                        to="/register"
                    >
                        {' '}
                        Cadastre-se
                    </Link>
                </p>
            </Content>
        </Container>
    )
}

export default Login
